/**
 * Applies the active language to the document root.
 *
 * Extracted from LanguageContext's effect so it can be tested, because the whole
 * app's Turkish typography depends on it. Browsers case-map per the element's
 * language, so every `text-transform: uppercase` label renders differently:
 *
 *   lang="tr"  "Kısmi çıktı"  ->  KISMI ÇIKTI   (correct: dotless ı -> I)
 *   lang="en"  "Kısmi çıktı"  ->  KISMI ÇIKTI   (i -> I, and "incelemesi"
 *                                  loses its dot: INCELEMESI, not İNCELEMESİ)
 *
 * Observed in a browser while reviewing the quality-warning panel: with the wrong
 * lang, Turkish uppercase headings degrade to dotless I and English ones gain a
 * dotted İ. Nothing covered this line, so removing it would have silently broken
 * every uppercase label in the app.
 */

/** Set `lang` and `dir` on the document root. Returns what was applied. */
export function applyDocumentLanguage(root, language, supportedLanguages) {
  if (!root) return null;
  const code = typeof language === 'string' && language.trim() ? language.trim() : 'en';
  const config = Array.isArray(supportedLanguages)
    ? supportedLanguages.find((entry) => entry && entry.code === code)
    : null;
  const dir = (config && config.dir) || 'ltr';
  root.lang = code;
  root.dir = dir;
  return { lang: code, dir };
}
